import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import RefreshAds from './RefreshAds';
import PostStream from 'flarum/forum/components/PostStream';
import safelyEvalAdScript from './safelyEvalAdScript';
import areAdsBypassed from './areAdsBypassed';
import isDevelopment from './isDevelopment';
export default function InsertBetweenPostsAds() {
  const AdCode = app.data['nagusi-ext-ads.ad-code.between_posts'];
  const Script = app.data['nagusi-ext-ads.ad-code.between_posts.js'];
  const dev = isDevelopment();
  const Html = dev ? m("p", null, "Anuncio") : m.trust(AdCode);
  override(PostStream.prototype, 'view', function (originalView) {
    if (areAdsBypassed()) return originalView();
    try {
      const originalVnode = originalView();
      const items = originalVnode.children || [];

      // Check if original items use keys to avoid "Vnodes must either always have keys or never have keys!"
      const hasKeys = items.length > 0 && items.some(item => item && typeof item === 'object' && item.key != null);
      const newItems = items.reduce((itemList, currentItem, i) => {
        const curr = [...itemList, currentItem];
        if (i + 1 < items.length && i % (parseInt(app.data['nagusi-ext-ads.between-n-posts']) || 15) === 0) {
          curr.push(m("aside", {
            key: hasKeys ? `nagusi-ad-${i}` : undefined,
            className: "nagusi-PostStream-item"
          }, m("div", {
            className: "nagusi-ad nagusi-ad-between-posts"
          }, Html)));
        }
        return curr;
      }, []);
      if (app.data['nagusi-ext-ads.enable-ad-after-placeholder'] === '1') {
        newItems.push(m("aside", {
          key: hasKeys ? 'nagusi-ad-after-placeholder' : undefined,
          className: "nagusi-PostStream-item"
        }, m("div", {
          className: "nagusi-ad nagusi-ad-between-posts nagusi-ad-between-posts--after-placeholder"
        }, Html)));
      }
      originalVnode.children = newItems;
      return originalVnode;
    } catch (e) {
      console.error('Nagusi Ads Error injecting between posts:', e);
      return originalView();
    }
  });
  extend(PostStream.prototype, ['onupdate', 'oncreate'], originalReturnVal => {
    if (areAdsBypassed() || dev) return;
    RefreshAds();
    safelyEvalAdScript('between posts', Script);
  });
}